var containerStyles = {"root":"Container_root__3qsfu","landscape":"Container_landscape__3TdyH","wrapper":"Container_wrapper__cZarY","listWrapper":"Container_listWrapper__3FKpA"};

export default containerStyles;
